<template>
    <table class="hourtable" style="margin-top: 225px;" @keydown.meta.left="multimode = true" @keyup.meta.left="multimode = false">
        <thead style="position: sticky;top: 275px; left: 0;z-index: 100; background-color: white; " v-if="loaded">
             <tr>
                <th></th>
                <th>
                    <div v-bind:style="{width: ''+getTaskWidth(-1)+'px'}">
                        <div class="circle" style="display: inline-block;vertical-align: middle;" v-on:click="toggleWorker({value: null})">?</div>
                        <template v-if="selectedWorkers.indexOf(null) != -1">Nieprzypisane</template>
                    </div>
                </th>
                <th :colspan="workers.length" style="padding: 0px">
                <draggable v-model="workers" group="workers" @start="drag=true" @end="workersDragEnd()" style="padding: 0px;  display: flex; flex-direction: row;">
                        <div v-for="(worker, index) in workers" :class="selectedWorkers.indexOf(worker.value) == -1 ? 'workerheader-closed' : 'workerheader-open'"  style="display: inline-block;vertical-align: middle;" v-bind:style="{width: ''+'px'}" v-if="worker.value != -1">
                          
                            <div style="display: inline-block; width: 30px;" class="circle" v-on:click="toggleWorker(worker)">{{worker.symbol}}</div>
                            <div style="display: inline-block;width: 100px;text-overflow: ellipsis;overflow: hidden;vertical-align: middle;" v-if="selectedWorkers.indexOf(worker.value) != -1">{{worker.name}}</div>
                            {{delayedTasksForWorker(date, worker.value).length > 0  && date.isSame(new Date(), 'date') ? '(' + delayedTasksForWorker(date, worker.value).length + ') ' : ''}}
                        </div>
                    
                </draggable>
                </th>
                <th></th>
            </tr>
        </thead>
        <preloader v-if="loaded == false || workersLoaded == false" n="6" />
        <tbody v-if="loaded"  @mouseup="holdStopped()" @mousedown="hold=true">
            <tr>
                <td style="width:  50px;"></td>
                <td v-bind:style="{width: ''+getTaskWidth(null)+'px'}">
                   
                    <div :draggable="!resizingUp && !resizingDown"  @dragstart="startDrag($event, task, undefined)" style="position: absolute; z-index: 99; font-size: small; border: 2px solid; overflow: hidden;" v-bind:class="{ 'intervention': task.typeof == 'intervention', 'inspection': task.typeof == 'inspection', 'installation': task.typeof == 'installation', 'other': task.typeof == 'other', 'task': selectedWorkers.indexOf(null) != -1, 'circle': selectedWorkers.indexOf(null) == -1, 'taskfinished': (task.status == 'finished_worker' | task.status == 'finished' | task.status == 'cancelled' | task.status == 'cleared' | task.status == 'refused'), 'dragging': dragging }" v-for="task in listWorkersItems['undefined']" v-bind:style="{ top:  '' + getTimeFraction(task.startsAt) + 'px' , left: 'calc(' + getTaskOffset(-1) + 'px )', height: 'calc('+  (selectedWorkers.indexOf(null) == -1  ? '30' : getTaskLength(task)) +'px )', padding:  'calc('+  (selectedWorkers.indexOf(null) == -1  ? '0' : '5') +'px )',  cursor: 'move'}" @dblclick="showTask(task)" v-on:click="shuffleTask(task, undefined)" :itemId="task.id" :workerId="undefined" >
                        <div style="cursor: ns-resize; height:10%; position: absolute; top: 0; width: 95%;" @mousemove="resizingUp = true" @mouseleave="exitResizingUp()" v-if="selectedWorkers.indexOf(-1) > -1"></div>
                        <template v-if="selectedWorkers.indexOf(null) != -1" @dragover.prevent @dragenter.prevent >
                            <template>
                                <p style="font-weight: bold; margin: 0px;" :key="task.id">
                                    <template v-if="date.isSame(task.startsAt, 'date')">
                                        {{task.startsAt | formatHour}}
                                    </template> - <template v-if="date.isSame(task.endsAt, 'date')">
                                        {{task.endsAt | formatHour}}
                                    </template>
                                    <template v-if="task.typeof == 'inspection' || task.typeof == 'installation'">{{tasksnames[task.typeof]}}</template>
                                    <template v-if="task.typeof == 'intervention'">
                                        <template v-if="task.intervention_type == 'other'">
                                            {{task.intervention_type_other}}
                                        </template>
                                        <template v-else>
                                            {{intervention_types[task.intervention_type]}}
                                        </template>
                                    </template>
                                    <template v-if="task.typeof == 'intervention' || task.typeof == 'other'">{{task.typeof_other}}
                                    </template>
                                </p>
                                <p style="margin-top: 5px; margin-bottom: 5px;">
                                    <template v-if="task.address != undefined"><b>{{[task.address.street, task.address.city].filter(v=>v!='').join(", ")}}</b></template>
                                    <template v-if="task.place_id != undefined"><b>{{placesdict[task.place_id]}}</b></template>
                                </p>
                                U: {{task.name}}
                            </template>
                        </template>
                        <template v-if="selectedWorkers.indexOf(null) == -1">
                            ?
                        </template>
                        <div style="cursor: ns-resize; height:10%; position: absolute; bottom: 0; width: 95%;" @mousemove="resizingDown = true" @mouseleave="exitResizingDown()" v-if="selectedWorkers.indexOf(-1) > -1"></div>
                    </div>
                </td>
                <td v-for="(worker, index) in workers" v-bind:style="{width: ''+getTaskWidth(index)+'px !important'}" v-if="worker.value != -1">
                     <div   style="position: absolute; top: 1200px; z-index: 99; font-size: small; border: 2px solid; overflow: hidden; width: 200px; padding: 15px; background-color: white;" v-if="delayedTasksForWorker(date, worker.value).length > 0 && date.isSame(new Date(), 'date')">
                        <strong>ZALEGŁE ZADANIA:</strong>
                        <template v-for="task in delayedTasksForWorker(date, worker.value)">
                            <div @dragstart="startDrag($event, task, worker)" @dblclick="showTask(task)" :itemId="task.id" draggable v-bind:class="{ 'intervention': task.typeof == 'intervention', 'inspection': task.typeof == 'inspection', 'installation': task.typeof == 'installation', 'other': task.typeof == 'other', 'dragging': dragging }">
                            <template v-if="selectedWorkers.indexOf(worker.value) != -1">
                            <p style="font-weight: bold;margin: 0px;text-transform: uppercase;" :key="task.id">
                                <template v-if="date.isSame(task.startsAt, 'date')">
                                    {{task.startsAt | formatHour}}
                                </template><template v-else> {{task.startsAt | formatDateWithHour}}</template> - <template v-if="date.isSame(task.endsAt, 'date')">
                                    {{task.endsAt | formatHour}}
                                </template><template v-else> {{task.endsAt | formatDateWithHour}}</template>
                                <b>
                                    <template v-if="task.typeof == 'inspection' || task.typeof == 'installation'">{{tasksnames[task.typeof]}}</template>
                                    <template v-if="task.typeof == 'intervention'">{{intervention_types[task.intervention_type]}}</template>
                                    <template v-if="task.typeof == 'intervention' || task.typeof == 'other'">{{task.typeof_other}}
                                    </template>
                                </b>
                            </p>
                            <p style="margin-top: 5px; margin-bottom: 5px;">
                                <template v-if="task.address != undefined"><b>{{[task.address.street, task.address.city].filter(v=>v!='').join(", ")}}</b></template>
                                <template v-if="task.place_id != undefined"><b>{{placesdict[task.place_id]}}</b></template>
                            </p>
                            U: {{task.name}}
                        </template>
                        </div>
                        </template>
                    
                    </div>
                    <div 
                    :draggable="!resizingUp && !resizingDown"
                    @dragstart="startDrag($event, task, worker)"
                    style="position: absolute; z-index: 99; font-size: small; border: 2px solid; overflow: hidden;"
                    v-bind:class="{ 'intervention': task.typeof == 'intervention', 'inspection': task.typeof == 'inspection', 'installation': task.typeof == 'installation', 'other': task.typeof == 'other', 'circle': selectedWorkers.indexOf(worker.value) == -1, 'task': selectedWorkers.indexOf(worker.value) != -1, 'notending': date.isSame(task.endsAt, 'day') == false, 'notstarting': date.isSame(task.startsAt, 'day') == false, 'taskfinished': (task.status == 'finished_worker' | task.status == 'finished' | task.status == 'cancelled' | task.status == 'cleared' | task.status == 'refused'), 'dragging': dragging }"
                    v-bind:style="{ top:  '' + getTimeFraction(task.startsAt) + 'px' , left: 'calc(' + getTaskOffset(index) + 'px )', height: 'calc('+  (selectedWorkers.indexOf(worker.value) == -1  ? '30' : getTaskLength(task)) +'px )', cursor: 'move'}" v-for="task in listWorkersItems[worker.value]"
                    @dblclick="showTask(task)"
                    @dragover.prevent
                    @dragenter.prevent
                    v-on:click="shuffleTask(task, worker.value)"
                    :itemId="task.id" :workerId="worker.value">
                        <div draggable  @dragstart="startDragBegin($event, task, worker)" style="cursor: ns-resize; height:10%; position: absolute; top: 0; width: 95%;" @mousemove="resizingUp = true" @mouseleave="exitResizingUp()" v-if="selectedWorkers.indexOf(worker.value) > -1"></div>
                        <template v-if="selectedWorkers.indexOf(worker.value) != -1">
                            <p style="font-weight: bold;margin: 0px;text-transform: uppercase;" :key="task.id">
                                <template v-if="date.isSame(task.startsAt, 'date')">
                                    {{task.startsAt | formatHour}}
                                </template><template v-else> {{task.startsAt | formatDateWithHour}}</template> - <template v-if="date.isSame(task.endsAt, 'date')">
                                    {{task.endsAt | formatHour}}
                                </template><template v-else> {{task.endsAt | formatDateWithHour}}</template>
                                <b>
                                    <template v-if="task.typeof == 'inspection' || task.typeof == 'installation'">{{tasksnames[task.typeof]}}</template>
                                    <template v-if="task.typeof == 'intervention'">{{intervention_types[task.intervention_type]}}</template>
                                    <template v-if="task.typeof == 'intervention' || task.typeof == 'other'">{{task.typeof_other}}
                                    </template>
                                </b>
                            </p>
                            <p style="margin-top: 5px; margin-bottom: 5px;">
                                <template v-if="task.address != undefined"><b>{{[task.address.street, task.address.city].filter(v=>v!='').join(", ")}}</b></template>
                                <template v-if="task.place_id != undefined"><b>{{placesdict[task.place_id]}}</b></template>
                            </p>
                            U: {{task.name}}
                        </template>
                        <template v-if="selectedWorkers.indexOf(worker.value) == -1">
                            {{worker.symbol}}
                        </template>
                        <svg v-if="pendingTimers[task.id]"
                               class="progress-circle"
                               viewBox="0 0 36 36">
                            <path
                              class="progress"
                              :stroke-dasharray="(pendingTimers[task.id].progress*100)+', 100'"
                              d="M18 2.0845
                                 a 15.9155 15.9155 0 0 1 0 31.831
                                 a 15.9155 15.9155 0 0 1 0 -31.831"
                            />
                          </svg>
                        <div draggable @dragstart="startDragEnd($event, task, worker)"  style="cursor: ns-resize; height:10%; position: absolute; bottom: 0; width: 95%;" @mousemove="resizingDown = true" @mouseleave="exitResizingDown()" v-if="selectedWorkers.indexOf(worker.value) > -1"></div>
                    </div>
                </td>
            </tr>
            <template v-for="hour in hours">
                <tr v-bind:style="{'background-color': (hoursselected.indexOf('' + hour+ ':00') > -1 ?  'rgba(0,0,0,0.12)' : 'initial')}"  @dblclick="addTask('' + hour+ ':00')" style="height: 25px;" @dragover.prevent @dragenter.prevent>
                    <th style="top: -26px; left: 0; z-index: 100; padding: 0px; height: 100px;" rowspan="4">
                        <div>
                            <span style="position: relative;top: -40px; left: 10px;user-select: none;">{{hour}}:00</span>
                        </div>
                    </th>
                    <td style="border-right: 1px solid gray;"></td>
                    <td droppable @drop="onDropOnCell($event, hour, 0, worker)" v-bind:style="{'min-width': (selectedWorkers.indexOf(worker.value) == -1 ? '50px' : '220px')}" style="border-right: 1px solid gray;" v-for="worker in workers"></td>
                </tr>
                <tr  v-bind:style="{'background-color': (hoursselected.indexOf('' + hour+ ':15') > -1 ?  'rgba(0,0,0,0.12)' : 'initial')}" @dblclick="addTask('' + hour+ ':15')" style="height: 25px;" @dragover.prevent @dragenter.prevent>
                    <td style="border-right: 1px solid gray;"></td>
                    <td droppable v-for="worker in workers" style="border-right: 1px solid gray;"  @drop="onDropOnCell($event, hour, 15, worker)"></td>
                </tr>
                <tr  v-bind:style="{'background-color': (hoursselected.indexOf('' + hour+ ':30') > -1 ?  'rgba(0,0,0,0.12)' : 'initial')}"  @dblclick="addTask('' + hour+ ':30')" style="height: 25px;" @dragover.prevent @dragenter.prevent>
                    <td style="border-right: 1px solid gray;"></td>
                    <td droppable v-for="worker in workers" style="border-right: 1px solid gray;" @drop="onDropOnCell($event, hour, 30, worker)"></td>
                </tr>
                <tr  v-bind:style="{'background-color':(hoursselected.indexOf('' + hour+ ':45') > -1 ?  'rgba(0,0,0,0.12)' : 'initial'), 'border-bottom-width': '2px'}"  @dblclick="addTask('' + hour+ ':45')" style="height: 25px;" @dragover.prevent @dragenter.prevent>
                    <td style="border-right: 1px solid gray;"></td>
                    <td droppable v-for="worker in workers" style="border-right: 1px solid gray;" @drop="onDropOnCell($event, hour, 45, worker)"></td>
                </tr>
            </template>
        </tbody>
        
    </table>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import Moment from 'moment';
import 'moment/locale/pl'
import { extendMoment } from 'moment-range';
import VueCookies from 'vue-cookies'

const moment = extendMoment(Moment);
moment.locale('pl')
export default {
    data: function() {
        return {
            hours: _.range(0, 24),
            tasksnames: { 'intervention': this.$t('tasks.kindnames.intervention'), 'inspection': this.$t('tasks.kindnames.inspection'), "installation": this.$t('tasks.kindnames.installation'), 'other': this.$t('tasks.kindnames.other') },
            intervention_types: { 'deratization': this.$t('tasks.intervention_names.deratization'), 'disinfection': this.$t('tasks.intervention_names.disinfection'), 'disinsection': this.$t('tasks.intervention_names.disinsection'), 'other': this.$t('tasks.intervention_names.other') },
            drags: {},
            multimode: false,
            resizingUp: false,
            resizingDown: false,
            dragging: false,
            hold: false,
            dragCoords: {},
            hoursselected: [],
            pendingTimers: {}
        }
    },
    props: {
        loaded: Boolean,
        workersLoaded: Boolean,
        days: {
            type: Array,
            default: []
        },
        workerItems: {
            type: Array,
            default: []
        },
        selectedWorkers: {
            type: Array,
            default: []
        },
        listWorkersItems: {
            type: Object,
            default: {}
        },
        delayedListWorkersItems: {
            type: Object,
            default: {}
        },
        placesdict: {
            type: Object,
            default: {}
        },
        date: {
            type: Object,
            default: {}
        }
    },
    created() {},
    mounted() {
        window.scrollTo(0, 800);
    },
    computed: {
        workers: {
            get() {
                return this.workerItems;
            },
            set(value) {
                this.$emit('reorder', value)
            }
        },
        collapsed: function(){
            return this.workerItems.length - this.selectedWorkers.length;
        },
        opened: function(){
            return this.selectedWorkers.length;
        },
        openedWithoutNone: function(){
            return _.compact(this.selectedWorkers).length;
        }

    },
    methods: {
        addToTime(hour, minutes){
            if(this.hold && !this.resizingUp && !this.resizingDown){
                var itemIndex = this.hoursselected.indexOf(hour);
                if(itemIndex < 0){
                    this.hoursselected.push(hour);
                }else{
                    this.hoursselected.splice(itemIndex + 1,this.hoursselected.length - itemIndex)
                }
                 console.log(this.hoursselected)
            }else{
                this.hoursselected = [hour];
            }
        },
         delayedTasksForWorker: function(date, worker_id){
            var that = this;
            return _.filter(this.delayedListWorkersItems[worker_id], function(task){
                return moment(task.startsAt).isBefore(date.startOf('day'));
            });
        },
        anyPending(){
            return Object.keys(this.pendingTimers).length > 0;
        },
        removeFromTime(hour){
            if(this.hold == false){
                this.hoursselected.splice(this.hoursselected.indexOf(hour),1);
            }
        },
        resetHold(){
            this.hold = false;
            this.hoursselected = [];
        },
        holdStopped(){
            var hourslist = this.hoursselected.map(function(hour){ return moment(hour, 'HH:mm').set({year: moment().get('year'), month: moment().get('month'), date: moment().get('date')})});
            if(hourslist.length > 0) this.addTask([moment.min(hourslist), moment.max(hourslist).clone().add(15, 'minutes')]);
            this.resetHold();
            this.dragging = false;
        },
        exitResizingUp(){
            console.log("Leaving upper resizer belt", this.dragging);
            if(this.dragging == false){
                this.resizingUp = false
            }
        },
        exitResizingDown(){
            console.log("Leaving lower resizer belt", this.dragging);
            if(this.dragging == false) this.resizingDown = false
        },
        startDrag(evt, item, worker) {
            console.log("Started dragging task");
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.setData('kind','wholeTask');
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('itemID', item.id)
            var interval = moment(item.startsAt, 'yyyy-MM-DDTHH:mm') - moment(item.endsAt, 'yyyy-MM-DDTHH:mm');
            if (worker != undefined) evt.dataTransfer.setData('workerID', worker.value)
            this.drags[item.id] = item;
            var rect = evt.target.getBoundingClientRect();
            this.dragCoords.x = evt.clientX - rect.left; //x position within the element.
            this.dragCoords.y = evt.clientY - rect.top; //y position within the element.
            this.dragCoords.starty = evt.clientY
            this.dragCoords.h = rect.height;
            this.dragCoords.hratio = ((this.dragCoords.y / rect.height))
            this.dragCoords.taskholded = Math.round((this.dragCoords.y / 100) * 4) * 15
            console.log(this.dragCoords.y, this.dragCoords.hratio);
            var that = this;
            requestAnimationFrame(() => {
                that.dragging = true;
            });
        },
        startDragBegin(evt, item, worker) {
            evt.stopPropagation(); 
            console.log("Started dragging task begin");
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.setData('kind','beginTask');
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('itemID', item.id)
            var interval = moment(item.startsAt, 'yyyy-MM-DDTHH:mm') - moment(item.endsAt, 'yyyy-MM-DDTHH:mm');
            if (worker != undefined) evt.dataTransfer.setData('workerID', worker.value)
            this.drags[item.id] = item;
            var rect = evt.target.getBoundingClientRect();
            this.dragCoords.x = evt.clientX - rect.left; //x position within the element.
            this.dragCoords.y = evt.clientY - rect.top; //y position within the element.
            this.dragCoords.starty = evt.clientY
            this.dragCoords.h = rect.height;
            this.dragCoords.hratio = ((this.dragCoords.y / rect.height))
            this.dragCoords.taskholded = Math.round((this.dragCoords.y / 100) * 4) * 15
            console.log(this.dragCoords.y, this.dragCoords.hratio);
            var that = this;
            requestAnimationFrame(() => {
                that.dragging = true;
            });
        },
        startDragEnd(evt, item, worker) {
            evt.stopPropagation(); 
            console.log("Started dragging task end");
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.setData('kind','endTask');
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('itemID', item.id)
            var interval = moment(item.startsAt, 'yyyy-MM-DDTHH:mm') - moment(item.endsAt, 'yyyy-MM-DDTHH:mm');
            if (worker != undefined) evt.dataTransfer.setData('workerID', worker.value)
            this.drags[item.id] = item;
            var rect = evt.target.getBoundingClientRect();
            this.dragCoords.x = evt.clientX - rect.left; //x position within the element.
            this.dragCoords.y = evt.clientY - rect.top; //y position within the element.
            this.dragCoords.starty = evt.clientY
            this.dragCoords.h = rect.height;
            this.dragCoords.hratio = ((this.dragCoords.y / rect.height))
            this.dragCoords.taskholded = Math.round((this.dragCoords.y / 100) * 4) * 15
            console.log(this.dragCoords.y, this.dragCoords.hratio);
            var that = this;
            requestAnimationFrame(() => {
                that.dragging = true;
            });
        },
        onDropOnCell(evt, list, mins, worker) {
            const itemID = evt.dataTransfer.getData('itemID')
            const item = this.drags[itemID];
            var diffTim = moment(item.endsAt).diff(moment(item.startsAt), 'minutes');
            var tim = moment(item.startsAt).set({ hour: list, minute: mins })
            var sameDay = this.date.isSame(item.startsAt, 'date');
            // tim = tim.add(diffTim, 'minutes')
            if(evt.dataTransfer.getData("kind") == "beginTask"){
                item.startsAt = moment(item.startsAt, 'yyyy-MM-DDTHH:mm').set({ hour: list, minute: mins }).format('yyyy-MM-DDTHH:mm')
            }else if(evt.dataTransfer.getData("kind") == "endTask"){
                item.endsAt = moment(item.endsAt, 'yyyy-MM-DDTHH:mm').set({ hour: list, minute: mins }).format('yyyy-MM-DDTHH:mm')
            }else{
                if(!sameDay){
                    item.startsAt = moment(item.startsAt, 'yyyy-MM-DDTHH:mm').set({ year: this.date.year(), month: this.date.month(), date: this.date.date(), hour: list, minute: mins }).format('yyyy-MM-DDTHH:mm')
                    item.endsAt = moment(item.startsAt).add(diffTim, 'minutes').format('yyyy-MM-DDTHH:mm')
                }else{
                    item.startsAt = moment(item.startsAt, 'yyyy-MM-DDTHH:mm').set({ hour: list, minute: mins }).format('yyyy-MM-DDTHH:mm')
                    item.endsAt = moment(item.startsAt).add(diffTim, 'minutes').format('yyyy-MM-DDTHH:mm')
                }
            }

            console.log("Task dropped on cell", list, mins, worker.name, itemID);
            var workerid = undefined;
            if (worker != undefined) workerid = worker.value;
            if (this.multimode) {
                if (item.worker_ids.indexOf(workerid) != -1) {
                    item.worker_ids.push(workerid);
                }
            } else {
                if (item.worker_ids.indexOf(workerid) > -1) {
                    if (item.worker_ids.indexOf(workerid) == -1) {
                        if (workerid != -1) {
                            item.worker_ids.splice(item.worker_ids.indexOf(workerid), 1, workerid);
                            if (item.worker_ids.length == 0) item.worker_ids.push(workerid);
                        } else item.worker_ids.splice(item.worker_ids.indexOf(workerid), 1);
                    }

                } else {
                    if(item.worker_ids.length == 1){
                        item.worker_ids.splice(0, 1);
                    }
                    item.worker_ids.push(workerid);
                }
            }
            var that = this;
            this.scheduleCommit(item);
            this.dragging = false;
        },
        workersDragEnd() {
            this.drag = false;
        },
        toggleWorker(worker) {
            if (this.selectedWorkers.indexOf(worker.value) == -1) this.selectedWorkers.push(worker.value)
            else this.selectedWorkers.splice(this.selectedWorkers.indexOf(worker.value), 1)
            this.$cookies.set('collapsedworkers', JSON.stringify(_.compact(_.uniq(this.selectedWorkers))));
            console.log(this.selectedWorkers);
        },
        initialsById(workers) {
            if (_.keyBy(this.workerItems, 'value')[workers[0]] == undefined) return "."
            return _.keyBy(this.workerItems, 'value')[workers[0]].symbol
        },
        showTask(task) {
            console.log("showtask", event)
            event.preventDefault();
            this.$emit('taskClicked', task)
        },
        shuffleTask(task, worker_id) {
            console.log("shuffleTask")
            var that = this;
            var overlaps = (_.filter(this.listWorkersItems[worker_id], function(tsk) {
                return task.startsAt <= tsk.startsAt && task.endsAt >= tsk.endsAt && tsk.id != task.id;
            }))
            if (overlaps.length > 0) {
                this.listWorkersItems[worker_id].splice(this.listWorkersItems[worker_id].indexOf(task), 1);
                this.listWorkersItems[worker_id].unshift(task)
            }
            this.$forceUpdate()
        },
        getTimeFraction(date) {
            var hh = moment(date).hours();
            var mm = moment(date).minutes();
            var startOfDay = moment(this.date).startOf('day');
            if (startOfDay.isBefore(date)) {
                return 176 + ((((hh + 2) * 60.0 + mm) / 60) * (124));
            } else {
                return 388;
            }
        },
        getTaskLength(task) {
            var endOfDay = moment(this.date).endOf('day');
            var startOfDay = moment(this.date).startOf('day');
            var mm = 0;
            if (moment(task.endsAt).isAfter(endOfDay)) {
                mm = moment(endOfDay).diff(moment(task.startsAt), 'minute')
            } else if (moment(task.startsAt).isBefore(startOfDay)) {
                mm = moment(task.endsAt).diff(startOfDay, 'minute')
            } else {
                mm = moment(task.endsAt).diff(moment(task.startsAt), 'minute')
            }
            return _.min([(mm / 60) * 122, 24 * 125]);
        },
        getTaskOffset(workerIndex) {
            var collapsed = 0;
            var opened = 0;
            var that = this;
            var openedna = false;
            if (workerIndex != -1) {
                if (that.selectedWorkers.indexOf(null) == -1) {
                    collapsed += 1;
                } else {
                    opened += 1;
                    openedna = true;
                }
                for (var i in _.range(workerIndex)) {
                    if (that.selectedWorkers.indexOf(that.workerItems[i].value) == -1) {
                        collapsed += 1;
                    } else {
                        opened += 1;
                    }
                }
            }
            return 60 + (opened * 220) + (collapsed * 50)
        },
        getTaskWidth(workerIndex) {
            if (workerIndex == -1) {
                if (this.selectedWorkers.indexOf(null) == -1) {
                    return 36;
                } else {
                    return 200;
                }
            }
            if (this.selectedWorkers.indexOf(this.workerItems[workerIndex]) == -1) {
                return 16;
            } else {
                return 200;
            }
        },
        getWorkerByCoord(xoffset) {
            for (var i = -1; i < this.workerItems.length; i++) {
                var from = this.getTaskOffset(i);
                var till = this.getTaskOffset(i + 1);
                if (from < xoffset && till > xoffset) return i;
            }
            if (this.selectedWorkers.indexOf(null) == -1) {
                if (16 < xoffset && 52 > xoffset) return null;
            } else {
                if (16 < xoffset && 200 > xoffset) return null;
            }
            return 0;
        },
        addTask(hour){
            this.$emit('addtask', hour);
        },
        scheduleCommit(task) {
          // clear any existing timer for this task
          if (this.pendingTimers[task.id]) {
            clearTimeout(this.pendingTimers[task.id].timer);
          }

          const duration = 30000; // 2 seconds
          const start = Date.now();

          // state object
          const state = {
            progress: 0,
            timer: null,
            raf: null,
          };

          // update progress animation
          const tick = () => {
            state.progress = (Date.now() - start) / duration;
            if (state.progress < 1) {
              state.raf = requestAnimationFrame(tick);
            }
          };
          tick();
          console.log("Scheduling commit in", duration, "ms");

          // commit after countdown
          state.timer = setTimeout(() => {
            cancelAnimationFrame(state.raf);
            this.$emit('taskmoved', task);
            delete this.pendingTimers[task.id];
          }, duration);

          this.$set(this.pendingTimers, task.id, state);
        }
    },
    watch: {},
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

/*p {
  font-size: 2em;
  text-align: center;
}*/
thead {
    font-size: 15px;
}

thead th {
    font-weight: 300;

}

table thead th:first-child {
    position: sticky;
    z-index: 2;
}

table>tr>td {

    padding-bottom: 5px;
}

thead>tr>td {
    padding-top: 5px;
}

.btn {
    color: black;
}

.btn.grey {
    background-color: #DADADA !important;
}

thead .input-field {
    margin-top: unset;
    padding-top: 5px;
    margin-bottom: unset;
}

.maincontainer {
    margin: 0px;
}

.calendartable td {
    padding: 0px 3px;
    font-size: 12px;
    text-align: center;
}

.calendartable tr {
    border-bottom: 0px;
}

.calendartable .red {
    background-color: #bbb;
    border-radius: 50%;
    text-align: center;
}

.calendartable .small {
    font-size: 2em;
}

.modal select {
    display: block !important;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.btn-add {
    border-radius: 8px;
    margin-top: 16px;
}

.task {
    position: absolute;
    max-width: 200px;
    width: 200px;
}

.intervention {
    background-color: rgba(244, 60, 250, 0.25);
    border: 2px solid rgba(244, 60, 250, 1.0) !important;
}

.inspection {
    background-color: rgba(250, 244, 60, 0.25);
    border: 2px solid rgba(250, 244, 60, 1.0) !important;
}

.installation {
    background-color: rgba(66, 250, 60, 0.25);
    border: 2px solid rgba(66, 250, 60, 1.0) !important;
}

.other {
    background-color: rgba(60, 117, 250, 0.25);
    border: 2px solid rgba(60, 117, 250, 1.0) !important;
}

.intervention,
.inspection,
.installation,
.other {
    padding: 5px;
}

th {
    position: sticky;
}

.circle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background-color: #DADADA;
    text-align: center;
    display: inline-block;
    padding: 0px !important;
}

.modal {
    top: 2% !important;
    max-height: 100%;
    background-color: #dadada;
}

.modal .modal-footer {
    background-color: #dadada;
}

.modal .btn-large {
    border-radius: 8px;
    color: black;
}

.label {
    line-height: 2;
}

.modal .green {
    margin-top: 10px;
    margin-bottom: 10px;
}

p {
    font-size: 10px;
    line-height: 2em;
}

.inspection {

    background-color: rgba(250, 244, 60, 0.25);
    font-size: medium;
}

.intervention {

    background-color: rgba(244, 60, 250, 0.25);
    font-size: medium;
}

/*.installation {

  background-color: rgba(60, 117, 250, 0.25);
  font-size: medium;
}*/
.week {
    width: calc(1 / 7 * 100%);

}

.daycolumn {
    width: calc(1 / 7 * 100%);
}

.cell {
    border: 1px solid;
    height: 200px;
    vertical-align: baseline;
}

.tasklist {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(5, 25px);
    grid-row-start: -1;
}

.tasklist>div {
    height: 25px;
}

.upper {
    text-transform: uppercase;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 5px;
    font-size: 12px;
}

.upper .circle {
    font-size: 15px;
}

.rightalign {
    text-align: end;
}

.workerheader-open>div {
    width: 200px;

}

.workerheader-closed>div {
    width: 23px;

}

/deep/ .collapsible-header {
    background-color: gray;
}

.collapsible i {
    right: 54%;
}

.hourtable tr {
    line-height: 1 !important;
}

/deep/ .dropdown-content {
    z-index: 102;
}

/deep/ .timepicker-modal {
    width: 75% !important;
}

/deep/ .timepicker-digital-display {
    background-color: #c22026 !important;
}

/deep/ .timepicker-canvas-bg {
    fill: #c22026 !important;
}

/deep/ .timepicker-canvas line {
    stroke: #c22026 !important;
}

/deep/ .timepicker-canvas-bearing {
    fill: #c22026 !important;
}

/deep/ .timepicker-tick:hover {
    background: #c22026 !important;
}

/deep/ .timepicker-close {
    color: #c22026 !important;
}

.removephoto {
    vertical-align: top;
    float: right;
    background-color: black;
    border: none;
    border-radius: 15px;
}

.removephoto i {
    color: white;
}

/deep/ ul#dropdownselectorplace {
    padding: 5px;
}

/deep/ ul#dropdownselectorplace label {
    color: black !important;
    font-size: 10px;
}

.task hr {
    margin: 0px !important;
    border-bottom-width: 0px;
    border-color: black;
}

.notstarting {
    border-top-width: 0px !important;
}

.notending {
    border-bottom-width: 0px !important;
}

/*.hourtable td:last-child {
    width: 100vw;
}*/
tr:hover{
    background-color: rgba(221, 221, 221, 0.5);
}
tr:hover th{
    background-color: rgba(221, 221, 221, 0);
}
tr th{
    background-color: #fff;
}
.workerheader-open{
    width: 220px;
}
.workerheader-closed{
    width: 50px;
}
.dragging {
    opacity: 0.5 !important;
    pointer-events: none;
}
.progress-circle {
  width: 20px;
  height: 20px;
}
.progress-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3;
}
.progress {
  fill: none;
  stroke: #007bff;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dasharray 0.1s linear;
}
</style>